import axios from "axios";
import { getAccessToken } from "../../../utils/okta-config";
import { BN_APP } from "../../../constants/constant";


// Function to handle file upload
export const uploadFile = async (formData, userId) => {
  const url = `${BN_APP}/billing-data/upload`;
  const requestOptions = {
    headers: {
      Authorization: `Bearer ${getAccessToken()}`, // Ensure getAccessToken() returns a valid token
      "Access-Control-Allow-Origin": process.env.REACT_APP_API_ROOT, // Ensure this is set correctly
    },
  };

  try {
    const response = await axios.post(url, formData, requestOptions);
    return response.data;
  } catch (error) {
    console.error("Error during file upload:", error);
    throw error;
  }
};

// Function to get upload status
export const getUploadStatus = async (batchRequestId) => {
  try {
    const response = await axios.get(`${BN_APP}/billing-data/upload/status/${batchRequestId}`, {
      headers: {
        Authorization: `Bearer ${getAccessToken()}`,
      },
    });
    return response.data;
  } catch (error) {
    console.error("Error polling progress:", error);
    throw error;
  }
};

export const downloadTemplate = async () => {
  try {
    const response = await axios.post(
      `${BN_APP}/billing-data/download`,
      null,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
        responseType: 'blob', // important for binary data
      }
    );

    const blob = new Blob([response.data], {
      type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    });

    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'upload_template.xlsx');
    document.body.appendChild(link);
    link.click();
    link.remove();

    // Get version from response headers
    const version = response.headers['x-template-version'];
    return version;
  } catch (error) {
    console.error('Error downloading template:', error);
    throw error;
  }
};

// Function to get template version information
export const getTemplateVersion = async () => {
  try {
    const response = await axios.get(
      `${BN_APP}/billing-data/template/version`,
      {
        headers: {
          Authorization: `Bearer ${getAccessToken()}`,
        },
      }
    );
    return response.data.data;
  } catch (error) {
    console.error('Error fetching template version:', error);
    throw error;
  }
};

